module.exports = __webpack_public_path__ + "img/branded-coin.015d4465.png";